import {
  IonButton,
  IonContent,
  IonIcon,
  IonLabel,
  IonPage,
  IonTabBar,
  IonTabButton
} from "@ionic/react";
import Header from "../components/Header";
import { useUsersStore } from "../stores/users.store";
import { updateAccount, storage } from "../lib/firebase";
import { Form, Formik } from "formik";
import TextInput from "../components/forms/TextInput";
import { useState } from "react";
import ImgInput from "../components/forms/ImgInput";
import { add } from "ionicons/icons";
import { ref, uploadBytes } from "firebase/storage";
import toast from "react-hot-toast";

const PROJECT_URL = "quidpro-903c6.appspot.com";

const resizeImage = async (file: File, maxWidth: number, maxHeight: number) => {
  return new Promise<Blob>((resolve: any, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const canvas = document.createElement("canvas");
      let { width, height } = img;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx!.drawImage(img, 0, 0, width, height);

      canvas.toBlob(resolve, file.type);
    };
    img.onerror = reject;
  });
};

const Profile: React.FC = () => {
  const user = useUsersStore(state => state.user);
  const [activeTab, setActiveTab] = useState("profile"); // ['profile', 'settings']
  const submitForm = async (values: any, { setSubmitting }: any) => {
    if (!user) return; // Safety check
    setSubmitting(true);
    const { firstName, lastName, username } = values;
    let { img } = values;
    const { userId } = user;
    if (typeof img !== "string") {
      // Upload image to storage
      const file = img;
      const filePath = `profiles/${userId}/` + file.name;
      const storageRef = ref(storage, filePath);
      const resizedImageBlob = await resizeImage(file, 256, 256);
      await uploadBytes(storageRef, resizedImageBlob);
      // url encode the file path
      const filename = encodeURIComponent(filePath);
      const newFilename = filename.replace(".jpeg", "_200x200.jpeg");
      img = `https://firebasestorage.googleapis.com/v0/b/${PROJECT_URL}/o/${newFilename}?alt=media`;
    }

    await updateAccount(user.userId, {
      img,
      firstName,
      lastName,
      username
    });
    setSubmitting(false);
    toast.success("Profile updated successfully", { duration: 3000 });
  };

  return (
    <IonPage>
      <Header title="Profile & App Settings" />
      <IonContent fullscreen>
        <IonTabBar
          onIonTabsDidChange={e => {
            setActiveTab(e.detail.tab);
          }}
          className="m-2 bg-black rounded-lg px-2"
        >
          <IonTabButton
            tab="profile"
            className={`text-base rounded-lg " ${
              activeTab === "profile" ? "bg-primary-50 text-white" : "bg-black"
            }`}
          >
            <IonLabel>Profile</IonLabel>
          </IonTabButton>
          <IonTabButton
            disabled
            tab="settings"
            className={`text-base rounded-lg " ${
              activeTab === "settings" ? "bg-primary-50 text-white" : "bg-black"
            }`}
          >
            <IonLabel>App Settings</IonLabel>
          </IonTabButton>
        </IonTabBar>
        {activeTab === "profile" && (
          <Formik
            initialValues={{
              img: user?.img || "",
              firstName: user?.firstName || "",
              lastName: user?.lastName || "",
              username: user?.username || "",
              password: ""
            }}
            onSubmit={submitForm}
          >
            {({ isSubmitting }) => (
              <Form>
                <ImgInput
                  name="img"
                  label="Profile Picture"
                  placeholder="Profile Picture"
                  type="avatar"
                />

                <div className="font-base  mx-6 mb-2">First name</div>
                <TextInput
                  name="firstName"
                  label="First name"
                  placeholder="Enter your first name"
                  className="rounded-[4px] mb-4"
                />
                <div className="font-base mx-6 mb-2">Last name</div>
                <TextInput
                  name="lastName"
                  label="Last name"
                  placeholder="Enter your last name"
                  className="rounded-[4px] mb-4"
                />
                <div className="font-base mx-6 mb-2">Username</div>
                <TextInput
                  name="username"
                  label="Username"
                  placeholder="Create your Username"
                  className="mb-4"
                />
                <IonButton
                  expand="block"
                  color="tertiary"
                  type="submit"
                  className="m-6"
                  disabled={isSubmitting}
                >
                  Update Details
                  <IonIcon slot="end" icon={add} />
                </IonButton>
              </Form>
            )}
          </Formik>
        )}
        {activeTab === "settings" && <div className="p-4"></div>}
      </IonContent>
    </IonPage>
  );
};

export default Profile;
